import React, { useRef, useEffect } from 'react';
import './AnimationShowcase.css';

const AnimationShowcase = () => {
  const ringRef = useRef(null);
  const necklaceRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          } else {
            entry.target.classList.remove('visible');
          }
        });
      },
      { threshold: 0.3 }
    );

    if (ringRef.current) observer.observe(ringRef.current);
    if (necklaceRef.current) observer.observe(necklaceRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section className="animation-showcase">
      <div className="showcase-container">
        <div className="showcase-item" ref={ringRef}>
          <div className="showcase-icon ring-icon">
            <img 
              src="https://plus.unsplash.com/premium_photo-1724762183134-c17cf5f5bed2?w=200&h=200&fit=crop" 
              alt="Gold Ring" 
              className="showcase-img"
            />
          </div>
          <div className="showcase-info">
            <h3 className="showcase-title">✨ Gold Plated Necklaces</h3>
            <p className="showcase-desc">Premium gold finish for every occasion</p>
          </div>
        </div>

        <div className="showcase-item" ref={necklaceRef}>
          <div className="showcase-icon necklace-icon">
            <img 
              src="https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=200&h=200&fit=crop&crop=center" 
              alt="Royal Necklace" 
              className="showcase-img"
            />
          </div>
          <div className="showcase-info">
            <h3 className="showcase-title">📿 Royal Necklaces</h3>
            <p className="showcase-desc">Statement pieces for special moments</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AnimationShowcase;